<template>
    <div class="go-fieldset">
        <div class="legend_title">{{title}}</div>
        <slot></slot>
    </div>
</template>

<script>

    export default {
        name: "go-fieldset",
        data() {
            return {

            };
        },
        props: {
            //标题
            title:{type:String,default:''}
        },
        computed: {

        },
        methods: {

        },
        mounted() {

        },
        watch: {

        },
        components: {
        }
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/layoutVue/go-fieldset.vue